import React from "react";
import { SquarePen, Trash } from "lucide-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { activeComponentValue } from "../redux/slice/ActiveComponentSlice";
import api from "../utils/api";
function DeleteClass({ classList }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleDelete = async (classId) => {
    try {
      const res = await api.delete("deleteClass", {
        params: { classId },
      });
      if (res.status === 200) {
        // console.log(res.data, "slime işlemi başarılır");
        dispatch(activeComponentValue(3));
        navigate("/routePage");
      }
    } catch (error) {
      console.error(error, "silme işlemi başarısız");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th
                className="px-6 py-4 text-left text-sm font-semibold
               text-gray-700 uppercase tracking-wider"
              >
                Sınıf adı
              </th>
              <th
                className="px-6 py-4 text-center text-sm font-semibold
               text-gray-700 uppercase tracking-wider"
              >
                Öğrenci sayısı
              </th>
              <th
                className="px-6 py-4 text-center text-sm font-semibold
               text-gray-700 uppercase tracking-wider"
              >
                Açıklama
              </th>

              <th
                className="px-6 py-4 text-center text-sm font-semibold
               text-gray-700 uppercase tracking-wider"
              >
                İşlemler
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {classList.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-50 transition-colors duration-200"
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  {value.className}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {value.students.length || "0"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {value.description}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex gap-2 ml-6 justify-center">
                    <button
                      className="bg-purple-500 w-26 h-10 rounded-lg text-white
                       hover:bg-purple-600 flex justify-center 
                       items-center gap-1 p-1 transition-colors"
                      onClick={() => handleStudent(student._id)}
                    >
                      {}
                      <SquarePen className="w-4 h-4" />
                      <span className="font-normal text-sm">Güncelle</span>
                    </button>
                    <button
                      className="bg-red-500 w-20 h-10 rounded-lg text-white
                         hover:bg-red-600 flex justify-center items-center
                          gap-1 p-1 transition-colors"
                      onClick={() => handleDelete(value._id)}
                    >
                      <Trash className="w-4 h-4" />
                      <span className="font-normal text-sm">Sil</span>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeleteClass;
